import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  changeField,
  pushElement,
  initializeForm,
  select,
  ans_check,
} from "../modules/problem";
import { check, setDomainNames } from "../modules/auth";
import { achievement } from "../modules/result";
import APITestForm from "../components/APITestForm";
import dayjs from "dayjs";

const APITestContainer = ({ history }) => {
  const dispatch = useDispatch();
  const [isTest, setIsTest] = useState(false);
  const [delay, setDelay] = useState(1000);
  const [src, setSrc] = useState("");
  const [seqNo, setSeqNo] = useState(0);
  const [ request, setRequest ] = useState([]);
  const {
    problem_info,
    select_problem,
    solved_problems,
    solved_domains,
    loading,
    next,
    achieve,
    auth,
    authError,
  } = useSelector(({ problem, loading, result, auth }) => ({
    problem_info: problem.problem_info,
    select_problem: problem.select,
    solved_problems: problem.solved_problems,
    solved_domains: problem.solved_domains,
    loading: loading,
    next: problem.next,
    achieve: result.achievement,
    auth: auth.auth,
    authError: auth.authError,
  }));

  /*
   * 토큰 유효성 검증
   */
  useLayoutEffect(() => {
    dispatch(check());
  }, [dispatch]);

  /*
   * 토큰이 유효하다면(auth 객체가 있다면) 문제 정보(problem_info), 푼 문제 목록(solved_problems), 푼 영역 정보(solved_domains)를 초기화한다.
   * select()로 푼 문제 목록과 푼 영역 정보, 현재 문제 출제 순서를 파라미터로 보내 다음 문제를 응답받는다.
   * domainNmaes(영역의 명칭)은 초등 / 중등, 학년 별로 다르므로 이후 사용될 도메인 영역 명칭을 위해 미리 설정해놓는다.(setDomainNames() 메소드 사용)
   *
   * waiting state를 통해 문제 제출 혹은 문제 로딩 중 문제 풀이를 방지한다.
   * 정답 제출 버튼은 항상 리액트 프론트의 ProblemViewForm에 존재하지만
   * 문제는 불러오기전까지 존재하지 않으므로 문제를 불러올때까지 정답 제출 버튼을 누를 수 없게 만들어야한다.
   */
    useEffect(() => {
      if (authError) {
        return;
      } else if (auth) {
        dispatch(initializeForm("problem_info"));
        dispatch(initializeForm("solved_problems"));
        dispatch(initializeForm("solved_domains"));
        dispatch(
          select({
            solved_problems: solved_problems,
            solved_domains: solved_domains,
            seq_no: 0,
          })
        );
        setRequest(request.concat(`[${dayjs().format('YYYY-MM-DD HH:mm:ss')}] POST /diagnosis/api/problem/select_problem`));
  
        let domainNames = [];
        const grade = parseInt(auth.grade);
        const st_month = parseInt(auth.st_month);
        if (grade >= 7) {
          domainNames = [
            ["수와 연산", "수와 연산"],
            ["문자와 식", "측정"],
            ["함수", "규칙성"],
            ["기하", "도형"],
            ["확률과 통계", "자료와 가능성"],
          ];
          if (grade === 7 && st_month <= 5) {
            domainNames[1] = ["측정", "측정"];
          }
        } else {
          domainNames = [
            ["수와 연산", "수와 연산"],
            ["도형", "도형"],
            ["측정", "측정"],
            ["규칙성", "규칙성"],
            ["자료와 가능성", "자료와 가능성"],
          ];
        }
        dispatch(setDomainNames(domainNames));
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [auth, authError, dispatch]);

  /*
   * 반복해서 API를 호출하는 Custom-Hooks (useInterval)
   * 선언 및 구현은 이 Container.js 아래쪽에서
   */

  useInterval(() => {
    if(loading["problem/SELECT"] === false) {
      if(select_problem) {
        if(select_problem.is_done) {
          dispatch(initializeForm("problem_info"));
          dispatch(initializeForm("solved_problems"));
          dispatch(initializeForm("solved_domains"));
          dispatch(
            select({
              solved_problems: solved_problems,
              solved_domains: solved_domains,
              seq_no: 0,
            })
          );
          setRequest(request.concat(`[${dayjs().format('YYYY-MM-DD HH:mm:ss')}] POST /diagnosis/api/problem/select_problem`));

    
          let domainNames = [];
          const grade = parseInt(auth.grade);
          const st_month = parseInt(auth.st_month);
          if (grade >= 7) {
            domainNames = [
              ["수와 연산", "수와 연산"],
              ["문자와 식", "측정"],
              ["함수", "규칙성"],
              ["기하", "도형"],
              ["확률과 통계", "자료와 가능성"],
            ];
            if (grade === 7 && st_month <= 5) {
              domainNames[1] = ["측정", "측정"];
            }
          } else {
            domainNames = [
              ["수와 연산", "수와 연산"],
              ["도형", "도형"],
              ["측정", "측정"],
              ["규칙성", "규칙성"],
              ["자료와 가능성", "자료와 가능성"],
            ];
          }
          dispatch(setDomainNames(domainNames));
        } else {
          dispatch(
            changeField({
              form: "solved_domains",
              key: "domain_cds",
              value: select_problem.solved_domains.domain_cds,
            })
          );
          for (
            let i = 0;
            i < select_problem.solved_domains.domain_cds.length;
            i++
          ) {
            let domain_cd = select_problem.solved_domains.domain_cds[i];
            let select_solved_domains = select_problem.solved_domains;
            dispatch(
              changeField({
                form: "solved_domains",
                key: domain_cd,
                value: select_solved_domains[domain_cd],
              })
            );
          }
          setSrc(
            `${process.env.REACT_APP_API_SERVER}/diagnosis/api/problem_view/${select_problem.seq_no}/${select_problem.problem_id}`
          );
          handleAnsCheck();
        }
      }
    }
  }, isTest ? delay : null);

  useEffect(() => {
      if(loading["problem/SELECT"] === false) {
      if(select_problem) {
        if(select_problem.is_done) {
          setRequest(request.concat(`-------------------- One Cycle Done --------------------`));
        }
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, loading, select_problem])

  const onLoad = () => {
    window.addEventListener("message", (e) => {
      if (e.origin === process.env.REACT_APP_API_SERVER) {
        let problem_info = e.data;
        for (let key in problem_info) {
          onChange({ name: key, value: problem_info[key] });
        }
      }
    });
  };
  const onChange = (e) => {
    const { value, name } = e;
    dispatch(
      changeField({
        form: "problem_info",
        key: name,
        value,
      })
    );
    if (name === "ansinput" && value === "null") {
      setSeqNo(seqNo + 1);
    }
  };

  const handleAnsCheck = () => {
    const { problem_id, ansinput } = problem_info;
    if (problem_id && ansinput) {
      dispatch(ans_check({ problem_id, ansinput }));
      setRequest(request.concat(`[${dayjs().format('YYYY-MM-DD HH:mm:ss')}] POST /diagnosis/api/problem/ans_check`));
    }
  };

  useEffect(() => {
    if (problem_info.is_right !== null) {
        dispatch(pushElement(problem_info));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, problem_info]);

  useEffect(() => {
    if (next !== null) {
      dispatch(
        achievement({ solved_problems: solved_problems, achieve: achieve })
      );
      dispatch(
        select({
          solved_problems: solved_problems,
          solved_domains: solved_domains,
          seq_no: select_problem.seq_no,
        })
      );
      setRequest(request.concat(`[${dayjs().format('YYYY-MM-DD HH:mm:ss')}] POST /diagnosis/api/problem/select_problem`));
      dispatch(initializeForm("problem_info"));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, next]);

  const handleDelayChange = (e) => {
    setDelay(Number(e.target.value));
  }

  const handleIsTestChange = () => {
    setIsTest(!isTest);
  } 

  return (
    <>
      {auth ? (
          <APITestForm 
            isTest={isTest}
            delay={delay}
            handleDelayChange={handleDelayChange}
            handleIsTestChange={handleIsTestChange}
            src={src}
            onLoad={onLoad}
            request={request}
          />
      ) : (
        <p>no</p>
      )}
    </>
  );
};

const useInterval = (callback, delay) => {
  const savedCallback = useRef();

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    const tick = () => {
      savedCallback.current();
    }
    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id)
    }
  }, [delay]);
};

export default withRouter(APITestContainer);
